import { Page } from "@/shared/page";

class PodcastEpisodePage extends Page {
  async init() {
    await super.init();
  }
}

const application = new PodcastEpisodePage();
window['application'] = application;
application.init();
